module.exports = __webpack_public_path__ + "img/import_empty.ed218496.png";